import React from "react";
import "../../Styles/Modal.css";
import { IoChevronBackOutline } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import TermsPdf from "../../assests/pdf/WedLuk_Terms.pdf";

function TermsModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  if (!isOpen) return null;

  return (
    <div className="modal-overlay-for-terms">
      <div className="terms-modal-container">
        <div className="client-setup-header-main">
          <div className="client-setup-header-left">
            <IoChevronBackOutline
              className="client-setup-back-icon"
              onClick={() => {
                navigate("/dashboard");
                onClose();
              }}
            />

            <img
              src={require("../../assests/images/nav_bar_logo.png")}
              alt="Wedluk Logo"
              className="client-setup-logo"
            />
          </div>

          <div className="client-setup-header-right">
            <span> Terms & conidtions</span>
          </div>
        </div>

        <div className="terms-content-card">
          <h3>Terms of Service</h3>

          <p className="terms-sub-title">
            This document outlines the policies, obligations, and conditions
            applicable to all users of the WedLuk platform
          </p>

          <div className="terms-content">
            <iframe
              src={`${TermsPdf}#toolbar=0&navpanes=0&view=FitH`}
              title="Terms and Conditions"
              width="100%"
              height="400"
              style={{ border: "none" }}
            />
            {/* <ol>
                         <li>
                           By creating an account, you confirm that all information
                           provided is accurate.
                         </li>
                         <li>
                           Users are solely responsible for the content shared through
                           profiles.
                         </li>
                         <li>
                           WedLuk reserves the right to suspend accounts with false
                           information.
                         </li>
                         <li>
                           Users agree to use the platform only for lawful matrimonial
                           purposes.
                         </li>
                         <li>
                           WedLuk may provide recommendations but does not guarantee
                           outcomes.
                         </li>
                         <li>
                           Membership plans and features may be modified or discontinued.
                         </li>
                         <li>Users are responsible for maintaining account security.</li>
                         <li>User data is processed according to the Privacy Policy.</li>
                         <li>
                           Users must comply with applicable laws and platform policies.
                         </li>
                         <li>
                           WedLuk is not liable for disputes arising from platform
                           connections.
                         </li>
                       </ol> */}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TermsModal;
